module.exports = __webpack_public_path__ + "static/media/80a8f0b0-ef84-4333-b37c-214d0a55f9a6.20a9125c.png";